(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trustpilot"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const maxSentences = parseInt('{{ section.settings.max_sentences }}', 10);

  function readMoreFunction(event) {
    event.preventDefault();
    const link = event.target;
    const reviewText = link.closest('.review-text');
    const fullText = reviewText.getAttribute('data-full-text');

    if (link.textContent === 'Weiter lesen') {
      reviewText.innerHTML = fullText + ' <a href="#" class="read-more" style="color: {{ section.settings.read_more_color }};">Weniger lesen</a>';
    } else {
      const truncatedText = fullText.split('. ').slice(0, maxSentences).join('. ') + '.';
      reviewText.innerHTML = truncatedText + '... <a href="#" class="read-more" style="color: {{ section.settings.read_more_color }};">Weiter lesen</a>';
    }

    reviewText.querySelector('.read-more').addEventListener('click', readMoreFunction);
  }

  document.querySelectorAll('.read-more').forEach(link => {
    link.addEventListener('click', readMoreFunction);
  });
});

  } catch(e) { console.error(e); }
})();
})();
